import clsx from 'clsx'
import React, { useEffect, useRef } from 'react'
import ReactPlayer from 'react-player'

import { AnalyticsActionType } from 'types/common/analytics.type'
import { adjustTextSize } from 'utils'
import { EVENTS, trackAnalytics } from 'utils/analytics'

import styles from './Hero.module.scss'
import mainStyles from '../../assets/css/main.module.scss'
import Bubble from '../common/bubble/Bubble'
import Circle from '../common/circle/Circle'
import { Flex } from '../common/flex/Flex'
import CommonFullScreenModal from '../common/fullScreenModal/FullScreenModal'
import Play from '../common/icons/play/Play'

const Hero = () => {
  // check if query param autoPlay is true
  const urlParams = new URLSearchParams(window.location.search)
  const autoPlayVideo = urlParams.get('autoPlayVideo') === 'true'
  const bubbleText = 'Define. Disrupt. Differentiate.'
  const [showCircle, setShowCircle] = React.useState(false)
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const [isVideoPlaying, setIsVideoPlaying] = React.useState(false)
  const containerRef = useRef<HTMLDivElement>(null)
  const textRef = useRef<HTMLDivElement>(null)

  const videoUrl =
    'https://facade-api-tccc-dev-stage.playground-stage.coke.com/api/file-manager/v1/tenants/571f9aa5-bb8b-4f9f-8835-23e74b64e050/files/e6bfb9b2-d5ac-4086-a073-4b17d27c98d1/public-download'

  const handleCircleClick = () => {
    setIsModalOpen(true)
    setIsVideoPlaying(true)

    trackAnalytics({
      type: AnalyticsActionType.action,
      payload: EVENTS.ACTIONS.PLAYGROUND_PP_HEADER_VIEWVIDEO,
    })
  }

  useEffect(() => {
    setTimeout(() => adjustTextSize(containerRef.current, textRef.current, 145), 100)

    // Adjust text size on window resize to maintain responsiveness
    window.addEventListener('resize', () => adjustTextSize(containerRef.current, textRef.current, 210))

    return () => {
      window.removeEventListener('resize', () => adjustTextSize(containerRef!.current, textRef!.current, 210))
    }
  }, [])

  useEffect(() => {
    if (autoPlayVideo) {
      // remove query param from url
      const newUrl = window.location.href.split('?')[0]
      window.history.replaceState({}, document.title, newUrl)
      setIsModalOpen(true)
      setIsVideoPlaying(true)
    }
  }, [autoPlayVideo])

  return (
    <div className={styles.container}>
      <div className={clsx(styles.containerText)} ref={containerRef}>
        <div ref={textRef} className={styles.weirdHeader}>
          PERSISTENT PLATFORM
        </div>
      </div>
      <div className={styles.background}>
        <div className="absolute bottom-0 w-full">
          <svg width="100%" height="400" viewBox="0 0 100 100" preserveAspectRatio="none" className="-mt-[400px]">
            <path d="M0,100 Q50,0 100,100 Z" fill="#CBE8E6" stroke="#CBE8E6" />
          </svg>
        </div>
      </div>
      {/* <BigText /> */}
      <Flex direction="column" gap={83} className={styles.contentContainer}>
        <div className="relative">
          <h2 className={clsx(mainStyles.h2, 'mt-[96px]')}>Persistent Platform</h2>
          <Bubble className={styles.bubble} text={bubbleText} color="#EBFF00" />
        </div>
        <Flex gap={44} className={styles.videoContainer}>
          <div
            data-testid="video-placeholder"
            className={styles.videoPlaceholder}
            onMouseEnter={() => setShowCircle(true)}
            onMouseLeave={() => setShowCircle(false)}
            onClick={handleCircleClick}
          >
            <Play width={50} height={50} color="black" className={styles.playIcon} />
            {showCircle && <Circle text="Watch it" textOnHover="Live it" onClick={handleCircleClick} />}
          </div>
          <Flex gap={24} direction="column" className="flex-1 max-w-[492px]">
            <p className={clsx(mainStyles.text, 'font-normal text-[#F4F4F4]')}>
              The Persistent Platform is a brand’s persistent point of view expressed through a long-lasting big idea
              addressing the consumer tension via the product in a unique way. The Framework is made up of the following
              elements: Persistent Humans, Persistent Relationships, Persistent Purpose, and, the new kid on the block,
              Persistent Product Edge.
            </p>
            <p className={clsx(mainStyles.text, 'font-normal text-[#F4F4F4]')}>
              This product-centric approach is designed to inspire and enhance how you tell each product’s unique story.
              <br />
              Click play on the video to learn more about this exciting addition to the framework.
            </p>
          </Flex>
        </Flex>
      </Flex>
      <CommonFullScreenModal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        title="Persistent Platform"
        setIsVideoPlaying={setIsVideoPlaying}
      >
        <ReactPlayer
          url={videoUrl}
          playing={isVideoPlaying}
          controls={true}
          width="100%"
          height="100%"
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
            flexGrow: 1,
          }}
        />
      </CommonFullScreenModal>
    </div>
  )
}

export default Hero
